<template>
  <v-navigation-drawer
    v-model="trialFlag"
    :width="500"
    absolute
    temporary
    right
    @input="setFlag"
  >
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>Extend Trial Period</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small  @click="closeDrawer" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list three-line>
      <div class="pa-4">
        <date-picker :color="datePickerColor"></date-picker>
      </div>
    </v-list>
    <v-footer absolute height="68">
      <v-flex>
        <div>
          <v-btn class="ml-4" v-if="loading" color="primary" loading></v-btn>
          <v-btn class="ml-4" v-else color="primary" :disabled="selectedDate === 'Not Set'" @click="updateTrialPeriod"
            >Update Trial Period</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import DatePicker from '@/components/admin/global/Datepicker';
import companyAPI from '@/api/company.js';

export default {
  name: 'TrialPeriodDrawer',
  components: {
    DatePicker,
  },
  props: {
    trialPeriodDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      selectedDate: 'Not Set',
      companyId: this.$route.params.id,
      loading: false,
      trialFlag: false,
    };
  },
  mounted() {
    this.setEventBus();
  },
  computed: {
    datePickerColor() {
      return this.$gf.headerColor();
    }
  },
  methods: {
    setFlag() {
      EventBus.$emit('TRIALPERIOD_DRAWER_STATE', this.trialFlag);
    },
    closeDrawer() {
      EventBus.$emit('TRIALPERIOD_DRAWER_STATE', false);
    },
    updateTrialPeriod() {
      if(this.$globalConfig.APP_NAME == 'direct'){
        this.loading = true;
        companyAPI
        .extendTrialPeriod(this.selectedDate, this.$route.params.id)
        .then(() => {
          this.loading = false;
          EventBus.$emit('TRIAL_PERIOD_STATE_UPDATED', true);
          this.closeDrawer();
        });
      }else if(this.$globalConfig.APP_NAME == 'partner'){
        this.loading = true;
      companyAPI
        .updateCompanyTrial(this.companyId, this.selectedDate)
        .then((resp) => {
          this.loading = false;
          EventBus.$emit('TRIAL_PERIOD_STATE_UPDATED', true);
          this.closeDrawer();
        });
      }
    },
    setEventBus() {
      EventBus.$on('DATE_SELECTED', (date) => {
        this.selectedDate = date;
      });
    },
  },
  watch: {
    trialPeriodDrawer: {
      handler(value) {
        this.trialFlag = value;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.v-picker--date .v-picker__title {
  display: none;
}
.v-picker--date .v-picker__body {
  margin: 0 auto !important;
}
</style>
